import { Col } from 'antd';
import { fieldAccessOptions } from './FieldAccessOptions';
import { PERISCOPE_FILTER_PLACEHOLDER } from '@sonar-software/sonar-ts-constants';
import React from 'react';
import { UpdateQueryParams } from '@hooks';
import { OptionFilter, SearchFilter, SearchFilterContainer, SearchFilterQueryParams } from '../filters';

export type EditAccessQueryParams = {
	hasEditAccess: boolean | null;
};

export type ProfileSearchQueryParams = SearchFilterQueryParams & EditAccessQueryParams;

export interface ProfileSearchProps {
	onChange: UpdateQueryParams<ProfileSearchQueryParams>;
}

export const ProfileSearch: React.FC<ProfileSearchProps> = ({ onChange }) =>
	<SearchFilterContainer>
		<Col span={ 12 }>
			<SearchFilter onChange={ onChange } />
		</Col>
		<Col span={ 12 }>
			<OptionFilter
				onChange={ (value) => onChange({ hasEditAccess: value ? value === 'true' : null }) }
				options={ fieldAccessOptions }
				placeholder={ PERISCOPE_FILTER_PLACEHOLDER.FILTER_BY_ACCESS } />
		</Col>
	</SearchFilterContainer>;

